(function() {
    'use strict';
    /*
     * Copyright (c) 2014-15 In Hand Health.
     * All rights reserved.
     */

    angular
        .module('ihh-common-web')
        .service('TimeSvc', TimeSvc);

    function TimeSvc() {
        var svc = this;
        svc.SECONDS_PER_MINUTE = 60;
        svc.MINUTES_PER_HOUR = 60;
        svc.HOURS_PER_DAY = 24;
        svc.MILLIS_PER_SECOND = 1000;
        svc.MILLIS_PER_MINUTE = svc.SECONDS_PER_MINUTE * svc.MILLIS_PER_SECOND;
        svc.MILLIS_PER_HOUR = svc.MINUTES_PER_HOUR * svc.MILLIS_PER_MINUTE;
        svc.MILLIS_PER_DAY = svc.HOURS_PER_DAY * svc.MILLIS_PER_HOUR;

        svc.nowInMillis = function() {
            return svc.today().getTime();
        };

        svc.today = function () {
            return new Date();
        };

        svc.tomorrow = function () {
            return new Date(svc.nowInMillis() + (svc.HOURS_PER_DAY * svc.SECONDS_PER_MINUTE * svc.MINUTES_PER_HOUR * svc.MILLIS_PER_SECOND));
        };

        svc.getDaysPlus = function(millis) {
            return millis / svc.MILLIS_PER_DAY;
        };

        svc.getDaysOnly = function(millis) {
            return Math.floor(svc.getDaysPlus(millis));
        };

        svc.getHoursPlus = function(millis) {
            var days = svc.getDaysOnly(millis);
            var accountedTime = days * svc.MILLIS_PER_DAY;
            var hours = (millis - accountedTime) / svc.MILLIS_PER_HOUR;
            return hours;
        };

        svc.getHoursOnly = function(millis) {
            return Math.floor(svc.getHoursPlus(millis));
        };

        svc.getMinutesPlus = function(millis) {
            var days = svc.getDaysOnly(millis);
            var hours = svc.getHoursOnly(millis);
            var accountedTime = days * svc.MILLIS_PER_DAY + hours * svc.MILLIS_PER_HOUR;
            var minutes = (millis - accountedTime) / svc.MILLIS_PER_MINUTE;
            return minutes;
        };

        svc.getMinutesOnly = function(millis) {
            return Math.floor(svc.getMinutesPlus(millis));
        };

        svc.getSecondsPlus = function(millis) {
            var days = svc.getDaysOnly(millis);
            var hours = svc.getHoursOnly(millis);
            var minutes = svc.getMinutesOnly(millis);
            var accountedTime = days * svc.MILLIS_PER_DAY + hours * svc.MILLIS_PER_HOUR + minutes * svc.MILLIS_PER_MINUTE;
            var seconds = (millis - accountedTime) / svc.MILLIS_PER_SECOND;
            return seconds;
        };

        svc.getSecondsOnly = function(millis) {
            return Math.floor(svc.getSecondsPlus(millis));
        };

        svc.formatTime = function(millis) {
            var formattedTime = '';
            var SEPARATOR = ':';
            var days = svc.getDaysOnly(millis);
            var hours = svc.getHoursOnly(millis);
            var minutes = svc.getMinutesOnly(millis);
            var seconds = svc.getSecondsPlus(millis);

            var formatSegment = function(unit) {
                return unit < 10 ? '0' + unit : unit;
            };

            if (days > 0) {
                formattedTime = formattedTime + days + SEPARATOR + formatSegment(hours) + SEPARATOR + formatSegment(minutes) + SEPARATOR + formatSegment(seconds.toFixed(3));
            }
            else if (hours > 0) {
                formattedTime = formattedTime + hours + SEPARATOR + formatSegment(minutes) + SEPARATOR + formatSegment(seconds.toFixed(3));
            }
            else if (minutes > 0) {
                formattedTime = formattedTime + minutes + SEPARATOR + formatSegment(seconds.toFixed(3));
            }
            else {
                formattedTime = formattedTime + seconds.toFixed(3);
            }

            return formattedTime;
        };
    }
})();